import mutate from 'js-core/js/apollo/mutations/mutate';
import invalidateQuery from 'js-core/js/apollo/mutations/invalidateQuery';

import UpdateSowingMutation from 'gql/mutations/Sowing/UpdateSowing.gql';
import DeleteSowingMutation from 'gql/mutations/Sowing/DeleteSowing.gql';

export default class{

    static update(input) {

        return mutate(UpdateSowingMutation, { input });
    }

    static delete(id) {

        return mutate(DeleteSowingMutation, { id }, store => {

            invalidateQuery(store, 'allSections');
            invalidateQuery(store, 'findSection');
        });
    }
}
